const GraphQLForm = require('app/graphql/Form');
const ConfirmModal = require('app/ui/modal/Confirm');
const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');

class Form extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitBillingPayment',
            'payment': null,
            'invoice': null,//need id,reference,customerName, remainingDue fields
            'autoComputeTotal': false,//if true, when invoice.amount change totalAmount change too
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.payment = this.settings.payment;
        this.invoice = this.settings.invoice;

        this.$form = $('<form/>')
        .addClass('billing-payment-form');

        this.loadData();

        super.initialize();
    }

    getPayment(){
        return this.payment;
    }

    getForm(){
        return this.$form;
    }

    refresh(){
        this.loadData();
    }

    loadData(){
        var self = this;

        this.$form.html('');

        let queries = [
            this.buildPaymentTypeQuery(),
            this.buildInvoiceQuery(),
        ];

        if(this.payment){
            queries.push(this.buildPaymentQuery());
        }

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.fillForm(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildPaymentQuery(){
        var self = this;

        let parameters = {
            'id': this.payment.id,
        };

        let fields = [
            'id',
            'type { id name }',
            'amount',
            'date',
            'comment',
            'invoiceAssociations { amount invoice { id reference date customerName remainingDue } }',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'billingPayment',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    buildInvoiceQuery(){
        var self = this;


        let filters = {
            'customerType': 'Restaurant',
            'fullyPayed': false,
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'filter': filters,
            'orderBy': 'date',
            'dir': 'ASC',
        };

        let fields = [
            'id',
            'reference',
            'date',
            'customerName',
            'remainingDue',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'billingInvoices',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    buildPaymentTypeQuery(){
        var self = this;


        let filters = {
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'filter': filters,
            'orderBy': 'name',
            'dir': 'ASC',
        };

        let fields = [
            'id',
            'name',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'billingPaymentTypes',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    fillForm(data){
        if(data.billingPayment){
            this.payment = data.billingPayment;
        }
        this.invoices = data.billingInvoices.edges;
        this.types = data.billingPaymentTypes.edges;

        if(this.payment && this.invoices.length <= 0){
            this.$form
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append(
                    $('<div/>')
                    .addClass('alert alert-danger')
                    .append(window.translate('app.billing.payment.form.noPendingInvoice'))
                )
            )
            return;
        }

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success')
        .append(window.translate('app.billing.payment.form.submit.label'));

        this.$form
        .append(this.buildInputs())
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-4')
            .append(this.$btnSubmit)
        );

        return this.$form;
    }

    getFields(){
        let fields = super.getFields();
        fields.push('payment { id }');
        return fields;
    }
    
    getVariables(){
        let variables = {
            'date': {
                'value': this.$dateInput.val(),
                'type': "Date"
            },
            'amount':{
                'value': parseFloat(this.$amountInput.val()),
                'type': "Float"
            },
            'type':{
                'value': parseInt(this.$typeSelect.val()),
                'type': "Int"
            }
        };

        if(this.payment){
            variables.payment = {
                'value': this.payment.id,
                'type': 'Int'
            }
        }

        return variables;
    }

    isCopy(){
        return this.settings.copyMode;
    }

    buildInputs(){
        var self = this;

        let $box = $('<div/>');

        let type = this.payment ? this.payment.type.id : null;
        let amount = this.payment ? this.payment.amount : null;
        let date = this.payment ? moment(this.payment.date).format('YYYY-MM-DD') : null;
        let comment = this.payment ? this.payment.comment : null;
        let invoiceAssociations = this.payment ? this.payment.invoiceAssociations : [];
        if(!amount && this.invoice){
            amount = this.invoice.remainingDue;
        }

        //FIELD date
        let now = moment().format('YYYY-MM-DD');
        if(!date){
            date = now;
        }
        let $dateLabel = $('<label/>')
        .attr('for','date')
        .append(window.translate('app.billing.payment.form.date.label'));
        this.$dateInput = $('<input/>')
        .attr('type','date')
        .attr('name','date')
        .attr('required','required')
        .addClass('form-control')
        .val(date);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($dateLabel)
            .append(this.$dateInput)
        )

        //FIELD type
        let $typeLabel = $('<label/>')
        .attr('for','type')
        .append(window.translate('app.billing.payment.form.type.label'));
        this.$typeSelect = $('<select/>')
        .attr('name','type')
        .addClass('form-control')
        .attr('required','required')
        .append(
             $('<option/>')
             .val('')
             .append('-')
        );
        let types = this.types;
        for(var i in types){
            let typeDefinition = types[i].node;
            let value = typeDefinition.id;
            let label = typeDefinition.name;

            let $option = $('<option/>')
            .val(value)
            .append(label);

            if(type == value){
                $option.attr('selected','selected');
            }
            this.$typeSelect.append($option);
        };
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($typeLabel)
            .append(this.$typeSelect)
        );

        //FIELD amount
        let $amountLabel = $('<label/>')
        .attr('for','amount')
        .append(window.translate('app.billing.payment.form.amount.label'));
        this.$amountInput = $('<input/>')
        .attr('type','text')
        .attr('name','amount')
        .attr('required','required')
        .addClass('form-control')
        .val(amount);
        let $btnComputeAmount = $('<button/>')
        .attr("type","button")
        .addClass('btn btn-outline-info')
        .attr('title',window.translate('app.billing.payment.form.amount.compute'))
        .append(
            $('<i/>')
            .addClass('fas fa-calculator')
        )
        .on('click',function(){
            self.computeTotalBasedOnInvoices();
        })
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($amountLabel)
            .append(
                $('<div/>')
                .addClass('input-group')
                .append(this.$amountInput)
                .append(
                    $('<div/>')
                    .addClass('input-group-append')
                    .append($btnComputeAmount)
                )
            )
            .append(
                $('<small/>')
                .addClass('text-muted')
                .append(window.translate('app.billing.payment.form.amount.helper'))
            )
        )

        //FIELD invoiceAssociations
        this.$invoicesContainer = $('<div/>')
        .addClass('pt-2');
        let index = 0;
        for(index in invoiceAssociations){
            let invoiceAssociation = invoiceAssociations[index];

            let invoice = invoiceAssociation.invoice;
            let amount = invoiceAssociation.amount;

            this.$invoicesContainer.append(this.buildInvoiceAssociationContainer(index,invoice,amount));
        }
        if(this.invoice){
            if(index){
                index+=1;
            }
            this.$invoicesContainer.append(this.buildInvoiceAssociationContainer(index,this.invoice,null));
        }

        let $invoiceAssociationsLabel = $('<label/>')
        .append(window.translate('app.billing.payment.form.invoiceAssociations.label'));
        let $btnAddInvoiceAssociation = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-sm btn-warning float-end')
        .append(
            $('<i/>')
            .addClass('fas fa-plus me-1')
        )
        .append(window.translate('app.billing.payment.form.invoiceAssociations.add'))
        .on('click',function(){
            self.onClickAddInvoiceAssociation()
        });
        $box.append(
            $('<div/>')
            .addClass('mt-2 pt-2')
            .append($btnAddInvoiceAssociation)
            .append($invoiceAssociationsLabel)
            .append(this.$invoicesContainer)
        )

        //FIELD comment
        let $commentLabel = $('<label/>')
        .attr('for','comment')
        .append(window.translate('app.billing.payment.form.comment.label'));
        this.$commentInput = $('<input/>')
        .attr('type','text')
        .attr('name','comment')
        .addClass('form-control')
        .val(comment);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($commentLabel)
            .append(this.$commentInput)
        )

        return $box;
    }

    onClickAddInvoiceAssociation(){
        let index = $('.billing-payment-invoice-association-container',this.$invoicesContainer).length;
        this.$invoicesContainer.append(this.buildInvoiceAssociationContainer(index,null,null));
    }

    buildInvoiceAssociationContainer(index,invoice,amount){
        var self = this;

        let prefix = 'invoiceAssociations['+index+']';

        let $container = $('<div/>')
        .attr('data-index',index)
        .addClass('billing-payment-invoice-association-container')
        .addClass('bg-light border-gray p-2 mb-1')
        .append(
            $('<button/>')
            .attr('type','button')
            .addClass('btn btn-text text-danger float-end')
            .append(
                $('<i/>')
                .addClass('fas fa-times')
            )
            .on('click',function(){
                self.onRemoveInvoiceAssociationContainer($container);
            })
        );

        let $row = $('<div/>')
        .addClass('row mt-1');


        let $invoiceContainer = $('<div/>')
        .addClass('col-6 d-flex ps-2 pe-2');

        if(!invoice){
            let $selectPendingInvoice = $('<select/>')
            .attr('id','pendingInvoiceSelect'+index)
            .attr('name',prefix+'[invoice]')
            .addClass('form-control')
            .attr('required','required')
            .append(
                $('<option/>')
                .val('')
                .append(window.translate('app.billing.payment.form.invoiceAssociations.choose'))
            )

            for(var i in this.invoices){
                let pendingInvoice = this.invoices[i].node;

                let label = pendingInvoice.reference + ' ('+pendingInvoice.customerName+')';

                let $option = $('<option/>')
                .addClass('billing-payment-pending-invoice-option')
                .data('amount',pendingInvoice.remainingDue)
                .val(pendingInvoice.id)
                .append(label);

                if(this.isInvoiceIdAlreadySelected(pendingInvoice.id)){
                    $option.attr('disabled','disabled');
                }

                $selectPendingInvoice
                .append($option);
            }

            $invoiceContainer.append($selectPendingInvoice);
        }else{

            let label = invoice.reference + ' ('+invoice.customerName+')';
            $invoiceContainer
            .addClass('align-self-center')
            .append(
                $('<div/>')
                .addClass('bg-light border-gray rounded w-100 p-3')
                .append(
                    $('<input/>')
                    .attr('type','hidden')
                    .addClass('billing-payment-invoice-input')
                    .attr('name',prefix+'[invoice]')
                    .val(invoice.id)
                )
                .append(
                    $('<span/>')
                    .addClass('fs-6')
                    .append(label)
                )
            )
        }

        if(!amount){
            if(invoice){
                amount = invoice.remainingDue;
            }
        }

        let $inputAmount = $('<input/>')
        .addClass('billing-payment-invoice-amount')
        .addClass('form-control')
        .attr('name',prefix+'[amount]')
        .attr('type','text')
        .attr('title',window.translate('app.billing.payment.form.invoiceAssociations.amount.label'))
        .attr('placeholder',window.translate('app.billing.payment.form.invoiceAssociations.amount.placeholder'))
        .attr('required','required')
        .val(amount)
        .on('change',function(){
            self.onChangeInvoiceAssociationAmount();
        });

        let $amountContainer = $('<div/>')
        .addClass('col-6')
        .append($inputAmount)
        .append(
            $('<small/>')
            .addClass('text-muted')
            .append(window.translate('app.billing.payment.form.invoiceAssociations.amount.helper'))
        )

        if(!invoice){
            $('select',$invoiceContainer)
            .on('change',function(){
                let $select = $(this);
                let $option = $('option:selected',$select);
                let amount = $option.data('amount');
                $inputAmount
                .val(amount)
                .trigger('change');
                self.disableSelectionForInvoice($option.val(),$option);
            })
        }

        $row
        .append($invoiceContainer)
        .append($amountContainer);

        $container.append($row);

        return $container;
    }

    isInvoiceIdAlreadySelected(id){
        if($('.billing-payment-invoice-input[value="'+id+'"]',this.$form).length > 0){
            return true;
        }
        if($('.billing-payment-pending-invoice-option[value="'+id+'"]:selected',this.$form).length > 0){
            return true;
        }
        return false;
    }

    computeTotal(){
        let total = 0;
        $('.billing-payment-invoice-amount',this.$form).each(function(){
            let $input = $(this);
            let amount = parseFloat($input.val());
            if(!isNaN(amount)){
                total += amount;
            }
        })
        return total;
    }

    onChangeInvoiceAssociationAmount(){
        if(this.settings.autoComputeTotal){
            let total = this.computeTotal();
            this.$amountInput.val(total);
        }
    }

    onRemoveInvoiceAssociationContainer($container){
        let invoiceIdSelected = null;
        

        let $input = $('.billing-payment-invoice-input',$container);
        if($input.length > 0){
            invoiceIdSelected = $input.val();
        }else{
            let $optionSelected = $('.billing-payment-pending-invoice-option:selected',$container);
            invoiceIdSelected = $optionSelected.val();
        }

        if(invoiceIdSelected){
            this.enableSelectionForInvoice(invoiceIdSelected);
        }

        $container.remove();

        this.onChangeInvoiceAssociationAmount();
    }

    enableSelectionForInvoice(id){
        $('.billing-payment-pending-invoice-option[value="'+id+'"]',this.$form).removeAttr('disabled');
    }

    disableSelectionForInvoice(id,$exceptedOption){
        $('.billing-payment-pending-invoice-option[value="'+id+'"]',this.$form).attr('disabled','disabled');
        if($exceptedOption){
            $exceptedOption.removeAttr('disabled');
        }
    }

    isValid(){
        let validity = super.isValid();

        if(!this.isTotalValid()){
            let error = window.translate('app.billing.payment.form.invalidTotal');
            this.$amountInput[0].setCustomValidity(error);
            window.notify(error,'danger');
            validity = false;
        }else{
            this.$amountInput[0].setCustomValidity('');
        }
        return validity;
    }

    isTotalValid(){
        let computedTotal = this.computeTotal();
        let inputTotal = parseFloat(this.$amountInput.val());
        if(computedTotal != inputTotal){
            return false;
        }
        return true;
    }

    computeTotalBasedOnInvoices(){
        let computedTotal = this.computeTotal();
        this.$amountInput.val(computedTotal).trigger('change');
    }

}

module.exports = Form;

